// @ts-nocheck
/**
 * Shipments Redux Sagas
 */

import { call, put, takeLatest, debounce } from 'redux-saga/effects'
import type { PayloadAction } from '@reduxjs/toolkit'
import { extractErrorMessage } from '@ufc/core'
import { shipmentsApi } from '../infrastructure/api/shipments-api'
import { shipmentsActions } from './shipments.slice'
import type { ShipmentsFilter, PaginatedShipments, ShipmentStats } from '../domain/types'

function* fetchShipmentsSaga(action: PayloadAction<ShipmentsFilter | undefined>) {
  try {
    const result: PaginatedShipments = yield call(shipmentsApi.getShipmentsPaginated, action.payload)
    yield put(shipmentsActions.fetchShipmentsSuccess(result))
  } catch (error) {
    yield put(shipmentsActions.fetchShipmentsFailure(extractErrorMessage(error)))
  }
}

function* fetchShipmentStatsSaga() {
  try {
    const stats: ShipmentStats = yield call(shipmentsApi.getShipmentStats)
    yield put(shipmentsActions.fetchShipmentStatsSuccess(stats))
  } catch (error) {
    yield put(shipmentsActions.fetchShipmentStatsFailure(extractErrorMessage(error)))
  }
}

function* onContextChangeSaga() {
  yield put(shipmentsActions.fetchShipments())
  yield put(shipmentsActions.fetchShipmentStats())
}

export function* shipmentsSaga() {
  yield takeLatest(shipmentsActions.fetchShipments.type, fetchShipmentsSaga)
  yield takeLatest(shipmentsActions.fetchShipmentStats.type, fetchShipmentStatsSaga)
  yield debounce(300, 'locations/selectLocation', onContextChangeSaga)
  yield debounce(300, 'locations/clearLocationSelection', onContextChangeSaga)
}
